import { csl } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

// [appFooter]
vuwer.add("appFooter", {
	selector: "#app_footer",
	
	onReady($self) {
		if(!$self) {
			csl.log.grey("no appFooter.");
			return false;
		}
	}
});
